module.exports = __webpack_public_path__ + "img/balanceBg-dark_a856a.png";